import React, { memo } from 'react';
import { ApolloError } from '@apollo/client';
import { FormRenderProps } from 'react-final-form';

import { useAppLayoutContextConsumer } from '@occc-app/design-system';
import { CanEditFormFields } from '@occc-app/App/CanEditFormFieldsContext';

import { AudienceUpdateForm } from './AudienceUpdateForm';
import { getAudienceUpdatePageHeaderLinks } from './utils/getAudienceUpdatePageHeaderLinks';

import { FormContent } from '../components/FormContent';

type AudienceUpdateFormRenderComponentProps = Pick<FormRenderProps, 'handleSubmit'> & {
  loading: boolean;
  audienceId: string;
  loaded: boolean;
  error?: ApolloError;
  clearFormField: (fieldName: string) => void;
  isUserPermittedToEditAudience: boolean;
  name?: string;
};

export const AudienceUpdateFormRenderComponent = memo(
  ({
    handleSubmit,
    name,
    loading,
    loaded,
    error,
    clearFormField,
    isUserPermittedToEditAudience,
  }: AudienceUpdateFormRenderComponentProps) => {
    const links = React.useMemo(() => {
      const updateLinkLabel = isUserPermittedToEditAudience
        ? `Edit ${name || ''}`
        : 'Audience Configurations';
      return getAudienceUpdatePageHeaderLinks(updateLinkLabel);
    }, [isUserPermittedToEditAudience, name]);

    useAppLayoutContextConsumer(links);

    return (
      <CanEditFormFields isEditable={isUserPermittedToEditAudience}>
        <AudienceUpdateForm
          loading={loading}
          loaded={loaded}
          error={error}
          handleSubmit={handleSubmit}
        >
          <FormContent clearFormField={clearFormField} />
        </AudienceUpdateForm>
      </CanEditFormFields>
    );
  },
);
